import React from "react";
import { Inbox } from "lucide-react";

const EmptyState = ({ title, description, action, icon }) => (
  <div className="neumorphic-card rounded-2xl p-10 text-center flex flex-col items-center justify-center my-6">
    <div className="w-16 h-16 rounded-2xl bg-purple-500/10 border border-purple-500/20 text-purple-600 dark:text-purple-400 flex items-center justify-center mb-4">
      {icon || <Inbox size={32} />}
    </div>
    <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100">
      {title || "Nenhum registro encontrado"}
    </h3>
    {description && (
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 max-w-md">
        {description}
      </p>
    )}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export default EmptyState;
